import { isIOS } from "react-device-detect";
import downloadMockup from "../assets/download.png";
import downloadBg from "../assets/DownloadBackground.png";
import AppStoreBadge from "../assets/App Store.svg";
import GooglePlayBadge from "../assets/Google Play.svg";

const appStoreUrl = "https://apps.apple.com/gb/app/luupli/id6463861554";
const playStoreUrl = "https://play.google.com/store/apps/details?id=com.dev.luupli.uat&hl=en_GB";

const DownloadSection = () => {
  return (
    <section className="bg-white py-16 md:py-20 lg:py-24 xl:py-28 2xl:py-32 overflow-hidden">
      <div className="max-w-[1520px] mx-auto px-4 md:px-6 lg:px-8 relative">
        <div
          className="
          relative
          flex flex-col items-center text-center
          lg:block lg:text-left
          rounded-none lg:rounded-[40px]
          px-4 py-8 lg:px-0 lg:py-0
          lg:pl-[3%] lg:pr-[48%] lg:pt-20 lg:pb-28 lg:min-h-[360px]
          xl:pl-[4%] xl:pr-[50%] xl:pt-28 xl:pb-36 xl:min-h-[420px]
          2xl:pl-[5%] 2xl:pr-[58%] 2xl:pt-40 2xl:pb-48 2xl:min-h-[520px]
        ">
          <img
            src={downloadBg}
            alt=""
            aria-hidden="true"
            className="hidden lg:block absolute inset-0 w-full h-full object-cover rounded-[40px] -z-0"
          />
          <div className="relative z-10 w-full max-w-[560px]">
            <h2 className="text-2xl sm:text-3xl lg:text-[30px] lg:leading-tight xl:text-[36px] 2xl:text-[clamp(42px,3vw,62px)] font-bold leading-tight text-black lg:whitespace-nowrap">
              Download Luupli Today
            </h2>

            <p className="mt-4 lg:mt-4 xl:mt-5 2xl:mt-6 text-sm sm:text-base lg:text-[15px] xl:text-[17px] 2xl:text-[clamp(18px,2vw,26px)] leading-relaxed text-black">
              Luupli solves unfair visibility and income by enabling collaborative
              content, shared discovery, and accessible global payouts for creators.
            </p>
            <div className="mt-8 lg:mt-8 xl:mt-10 2xl:mt-14 flex items-center justify-center lg:justify-start gap-3 lg:gap-[14px] flex-wrap">
              <a
                href={appStoreUrl}
                target="_blank"
                rel="noreferrer"
                className={`${isIOS ? "block" : "hidden"} lg:block`}
              >
                <img
                  src={AppStoreBadge}
                  alt="Download on the App Store"
                  className="h-10 lg:h-[48px] xl:h-[52px] 2xl:h-[61px] w-auto"
                />
              </a>
              <a
                href={playStoreUrl}
                target="_blank"
                rel="noreferrer"
                className={`${isIOS ? "hidden" : "block"} lg:block`}
              >
                <img
                  src={GooglePlayBadge}
                  alt="Get it on Google Play"
                  className="h-10 lg:h-[48px] xl:h-[52px] 2xl:h-[61px] w-auto"
                />
              </a>
            </div>
          </div>
          <img
            src={downloadMockup}
            alt="Luupli app preview"
            className="
              mt-8 w-full max-w-[500px] mx-auto
              lg:mt-0 lg:mx-0 lg:max-w-none lg:absolute lg:-right-4 lg:-top-20 lg:w-[400px]
              xl:-right-6 xl:-top-28 xl:w-[520px]
              2xl:-right-10 2xl:-top-32 2xl:w-[720px]
              drop-shadow-[0_25px_40px_rgba(0,0,0,0.15)] lg:drop-shadow-[0_32px_48px_rgba(0,0,0,0.16)] xl:drop-shadow-[0_40px_60px_rgba(0,0,0,0.18)] 2xl:drop-shadow-[0_55px_80px_rgba(0,0,0,0.22)]
            "
          />
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;